import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeIdentityPartnerListScreen from './screens/ChargeIdentityPartnerListScreen';

function ChargeIdentityPartner() {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeIdentityPartnerListScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeIdentityPartner;
